module.exports = __webpack_public_path__ + "img/sec2.4.9b1bc575.png";